GestionStocksFiltresValidator.$inject = ['validator'];

export default function GestionStocksFiltresValidator(validator) {
    const instance = new validator();

    instance.ruleFor('idSite').notEmpty().withMessage('VALIDATION_NOTEMPTY');
    instance.ruleFor('dateDebut').notEmpty().withMessage('VALIDATION_NOTEMPTY');
    instance.ruleFor('dateFin').notEmpty().withMessage('VALIDATION_NOTEMPTY');
    instance.ruleFor('eltNiv1').notEmpty().withMessage('VALIDATION_NOTEMPTY');

    return instance;
}
